const styles = {
    doneEqueuesList: {
        // marginLeft: "4.2vw",
        paddingLeft: "17px"
    }
}

export default styles;
